import lazyScreen from '../utils/lazyScreen';
const Vendor = lazyScreen(() => import('../pages/vrm/Vendor/index.js'), 'pages/vrm/Vendor/index.js');
const Vendors = lazyScreen(() => import('../pages/vrm/Vendors/index.js'), 'pages/vrm/Vendors/index.js');

export default [
    {
        path: '/vrm/Vendor/:code',
        component: Vendor
    },
    {
        path: '/vrm/Vendors',
        component: Vendors
    }
];
